import { useGetSegmentationDetailsMutation } from "../api/forecastSegmentationApi";

export const useSegmentationDetails = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetSegmentationDetailsMutation();
  
    return {
      mutate,
      isLoading,
      isSuccess,
      isError,
      error,
      data,
    };
  };
  